import * as React from "react";
import { Box, Grid } from "@material-ui/core";

import StatusInput from "../components/StatusInput";
import TextInputRA from "../components/TextInputRA";
import LayoutContainer from "../components/LayoutContainer";
import LeftGridCreate from "../components/LeftGridCreate";
import HiddenInputRA from "../components/HiddenInputRA";
import RightGridCreate from "../components/RightGridCreate";
import CategoryValidation from "../../../ValidationRules/CategoryValidation";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";
/*
{
  "locale": "en-US",
  "type": "Product",
  "name": "Ear Pod",
  "desc": "description",
  "base_price": 1000,
  "retail_price": 10000,
  "currency": "THB",
  "unit": "Piece",
  "hashtags[]": [
    "#iphone"
  ],
    "status": "Active",
  "sub_category_id": "xxxxxx-5902ca0b0257bb14df426921",
  "category_id": "xxxxxx-5902ca0b0257bb14df426921",
  "realm_id": "xxxxxx-5902ca0b0257bb14df426921",
  "branch_id": "xxxxxx-5902ca0b0257bb14df426921",
  "action": "upload_image"
*/

const CategoryCreate = (props) => (
  <LayoutContainer>
    <Grid container style={{ height: "100%" }}>
      <LeftGridCreate {...props} validate={CategoryValidation}>
        <SfBreadcrumbs path="Management/Categories/New Category" />
        <Box style={{ margin: 50 }}>
          <TextInputRA
            placeholder="Category name"
            required
            label="Category name"
            source="name"
          />
          <TextInputRA
            placeholder="Description"
            label="Description"
            source="desc"
          />
          <StatusInput />
          <HiddenInputRA source="type" initialValue="Product" />
        </Box>
      </LeftGridCreate>
      <RightGridCreate />
    </Grid>
    {/* <Create {...props} title="Create Category">
      <SimpleForm>
        <TextInputRA label="Category name" source="name" />
        <TextInputRA label="Description" source="desc" />
        <HiddenInputRA source="status" initialValue="Active" />
        <HiddenInputRA source="type" initialValue="Product" />
      </SimpleForm>
    </Create> */}
    <PermissionChecker code="Page.Merchant.Management.Category" write />
  </LayoutContainer>
);

export default CategoryCreate;
